import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import { navLinks } from "@/mocks/site";

export default function NotFound() {
  return (
    <SiteLayout>
      <div className="mx-auto flex w-full max-w-shell flex-col items-center px-4 py-24 text-center md:px-6">
        <p className="font-heading text-7xl font-black text-primary-100 select-none md:text-9xl">404</p>
        <h1 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
          这条爆料暂时不存在
        </h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          页面可能已被更正、合并或下线。你可以从下面的入口继续浏览最新的独家内容。
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-2">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="cursor-pointer whitespace-nowrap rounded-full border border-background-300 px-4 py-1.5 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600"
            >
              {link.label}
            </Link>
          ))}
        </div>
        <Link
          to="/"
          className="mt-8 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600"
        >
          <i className="ri-arrow-left-line" aria-hidden="true" />
          返回首页
        </Link>
      </div>
    </SiteLayout>
  );
}